module.exports = __webpack_public_path__ + "img/contact.d4b87437.svg";